import React, { ReactNode, useEffect, useRef } from 'react';
import cx from 'clsx';
import ClipboardJS from 'clipboard';
import message from 'antd/es/message';

import style from './index.module.scss';

type CopyButtonProps = {
  text: string;
  className?: string;
  children: ReactNode;
  showMessage?: boolean;
  successMessage?: string;
  disabled?: boolean;
};

export const CopyButton = ({
  text,
  showMessage = true,
  children,
  className,
  successMessage = 'Copied',
  disabled,
}: CopyButtonProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const clipboardRef = useRef<ClipboardJS>();

  useEffect(() => {
    if (!disabled && ref.current) {
      // 需要一进来就声明它，它自己会监听 onclick，api 设计得奇怪
      clipboardRef.current = new ClipboardJS(ref.current, {
        text: () => text,
      }).on('success', () => {
        if (showMessage) {
          message.success(successMessage);
        }
      });
    }

    return () => {
      clipboardRef.current?.destroy();
    };
  }, [text, disabled, showMessage, successMessage]);

  return (
    <div className={cx(style.clipboardBtn, className)} ref={ref}>
      {children}
    </div>
  );
};
